<template>
	<v-container fluid fill-height class="content-pad-vert">
		<v-layout row wrap>
			<v-flex xs12 sm12 md3 class="pr-4">
				<v-list>
					<v-list-tile :to="{ name: 'host_dashboard' }" exact>
						<v-list-tile-action>
							<v-icon>fal fa-home</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>Dashboard</v-list-tile-title>
					</v-list-tile>
					<v-list-tile :to="{ name: 'host_dashboard_upcoming_events'}">
						<v-list-tile-action>
							<v-icon>fal fa-calendar-alt</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>Upcoming Events</v-list-tile-title>
					</v-list-tile>
					<v-list-tile
						v-for="(event, i) in getMyEvents"
						:key="i"
						:to="{ name: 'host_dashboard_event_details', params: { slug: event.slug }}"
					>
						<v-list-tile-action class="pl-4">
							<v-icon>fal fa-calendar</v-icon>
						</v-list-tile-action>
						<v-list-tile-title v-text="event.title"></v-list-tile-title>
					</v-list-tile>
					<v-list-tile :to="{ name: 'host_dashboard_past_events'}">
						<v-list-tile-action>
							<v-icon>fal fa-calendar-minus</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>Past Events</v-list-tile-title>
					</v-list-tile>
					<v-list-tile :to="{ name: 'host_dashboard_locations'}">
						<v-list-tile-action>
							<v-icon>fal fa-map-marker</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>My Locations</v-list-tile-title>
					</v-list-tile>
					<v-list-tile :to="{ name: 'host_dashboard_faq'}">
						<v-list-tile-action>
							<v-icon>fal fa-question</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>Hosting FAQ</v-list-tile-title>
					</v-list-tile>
					<v-list-tile :to="{ name: 'host_dashboard_settings'}">
						<v-list-tile-action>
							<v-icon>fal fa-cog</v-icon>
						</v-list-tile-action>
						<v-list-tile-title>Host Settings</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-flex>
			<v-flex xs12 sm12 md9>
				<router-view></router-view>
			</v-flex>
		</v-layout>
		<!-- <v-layout row wrap v-else>
			<v-flex xs12 sm8 offset-sm2 class="mt-5">
				<v-card flat style="background-color: transparent;" class="mb-2" v-if="userHasHostRequest && (getStep <=3)">
					<v-card-title v-if="getStep <= 3">
						<p class="host-dashboard-title mb-0 pb-0" v-if="getStep <= 3">Your host application</p>
						<p class="host-dashboard-title mb-0 pb-0" v-else>Your host application is complete!</p>
					</v-card-title>
					<v-card-text>
						<v-layout row wrap align-center>
							<v-stepper vertical class="elevation-0" :value="getStepperStep" style="background: transparent;" v-if="getStep <= 3">
								<v-stepper-step step="1" :complete="getStepperStep > 1" class="host-dashboard-step">Personal Information</v-stepper-step>
								<v-stepper-step step="2" :complete="getStepperStep > 2" class="host-dashboard-step">
									Location Information
								</v-stepper-step>
							</v-stepper>
							<v-flex offset-md3 md4 offset-lg4 lg4 xs12 v-if="getStep <= 3">
								<div class="pa-3">
									<p class="host-dashboard-sub-title">You're almost done!</p>
									<p class="host-dashboard-content">It will only take a few minutes to finish your host application.</p>
									<v-btn block class="btn-blue" @click="goToCurrentStep">Continue Application</v-btn>
								</div>
							</v-flex>
							<v-flex xs12 sm6 offset-sm3 v-else>
								<v-card flat class="pa-3">
									<p class="host-dashboard-sub-title">Thanks for applying to become a wrkprty host!</p>
									<p class="host-dashboard-content">
										Our team will review your application ASAP.
									</p>
									<p class="host-dashboard-content">
										Look out for an email follow-up from us soon.
									</p>
									<p class="host-dashboard-content">
										Once approved, you will be able to create your own event listings!
									</p>
								</v-card>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout> -->
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import {getAddressStringFromObject, get12hTimeString} from '~/utils/helper'
export default {
	name: 'host_dashboard_shell',
	data () {
		return {
			locationNotificationOpen: true,
			eventNotificationOpen: true,
			hostApplicationSuccessModal: false
		}
	},
	created() {
		console.log('HostDashboard')
		let params = window.location.search.slice(1).split(/[\?\&]+/)
		for (let param in params) {
			let prop = params[param].split('=')[0]
			let value = params[param].split('=')[1]
			if (prop === 'host-application') {
				this.hostApplicationSuccessModal = true
			}
		}
	},
	mounted() {
		this.fetchAllEvents()
		this.fetchAllLocations()
	},
	methods: {
		...mapActions([
			'fetchAllEvents',
			'fetchAllLocations',
		]),
		getAddress(location) {
			return getAddressStringFromObject(location)
		}
	},
	computed: {
		...mapGetters([
			'getMyEvents',
			'getHostProp',
			'getMyLocations',
			'getAddEventStateEmpty',
			'getAddLocationStateEmpty',
			'userHasHostRequest',
			'getHostProcessStep',
			'getHost',
			'userIsHost'
		])
	}
}
</script>

<style lang="scss">
.next-step {
	background-color: gray;
	color: white;
	width: 50px;
	height: 50px;
	border-radius: 50%;
}

.stepper__step--complete {
	.primary {
		background-color: #25e684 !important;
	}
}

.stepper__step--active {
	.primary {
		background-color: #25e684 !important;
	}
}
</style>
